
/* global angular:false */

(function () {
    "use strict";

    angular.module("vendd")
        .controller('CheckoutShippingMethodController', function ($scope, $q, $element, ControlService, Validation) {
            $scope.Model = $scope.Model || {};
            $scope.Control = $scope.Control || {};

            var controlName = 'ShippingMethod';
            $scope.registerControl(controlName, $element.get(0));

            if (checkoutConfig && checkoutConfig.customShippingMethods) {
                $scope.Control.Methods = checkoutConfig.customShippingMethods;
            }

            $scope.Control.Form = {};
            $scope.Control.IsValid = true;
            $scope.Control.SelectedMethod = 0;
            $scope.Control.SelectedCompany = 0;
            $scope.Control.SelectedCompanyCode = '';
            $scope.Control.Loading = false;

            var validators = [];
            var initiallyValidated = false;

            var options = {
                callback: function (value) {
                    var fieldName = $(this).data("fieldname");
                    var validate = $(this).data("validate");

                    if (validate)
                        $scope.Control.validateField('Control.Form.' + fieldName);
                },
                wait: 750,
                highlight: false,
                allowSubmit: false,
                captureLength: 1
            };

            $element.find("input[type = text], input[type = tel]").typeWatch(options);

            $scope.Control.validateField = function (name) {
                if (initiallyValidated) {
                    _.first(_.filter(validators, function (x) { return x.name === name })).fn();
                }
            };

            validators.push({
                name: 'Control.Form.Name',
                fn: function () {
                    Validation.reset($scope, 'Control.Form.Name');
                    if ($scope.Model.Data.Config.IsUserCourierCompanyNameVisible && $scope.Model.Data.Config.IsUserCourierCompanyNameRequired) {
                        Validation.require($scope, 'Control.Form.Name').then(function (response) { }, function (error) { });
                    }
                }
            });

            validators.push({
                name: 'Control.Form.Address',
                fn: function () {
                    Validation.reset($scope, 'Control.Form.Address');
                    if ($scope.Model.Data.Config.IsUserCourierCompanyAddressVisible && $scope.Model.Data.Config.IsUserCourierCompanyAddressRequired) {
                        Validation.require($scope, 'Control.Form.Address').then(function (response) { }, function (error) { });
                    }                    
                }
            });

            validators.push({
                name: 'Control.Form.Phone',
                fn: function () {
                    Validation.reset($scope, 'Control.Form.Phone');
                    if ($scope.Model.Data.Config.IsUserCourierCompanyPhoneVisible) {
                        if ($scope.Model.Data.Config.IsUserCourierCompanyPhoneRequired) {
                            Validation.require($scope, 'Control.Form.Phone').then(function (response) {
                                if (checkoutConfig.phoneLocalizationEnabled) {
                                    var $inputPhone = $('.form-row.phone.js-phone-localization input', $element);
                                    Validation.isValidPhoneLocalized($scope, 'Control.Form.Phone', $inputPhone, $inputPhone.data('localized-validation'), {

                                    }).then(function (response) {
                                    }, function (error) {
                                        $scope.Control.IsOpen = true;
                                    });
                                } else if ($scope.Control.Form.Country === 'GR' && checkoutConfig.greekPhoneValidation) {
                                    $scope.Model.Data.Config.IsGreekPhone = true;
                                    Validation.isMatch($scope, 'Control.Form.Phone', /^2[0-9]{9}$/g, {

                                    }).then(function (response) {
                                    }, function (error) {
                                        $scope.Control.IsOpen = true;
                                    });
                                } else {
                                    $scope.Model.Data.Config.IsGreekPhone = false;
                                    Validation.isMatch($scope, 'Control.Form.Phone', /^[\+]?[\d]+$/g, {

                                    }).then(function (response) {
                                    }, function (error) { });
                                }
                            }, function (error) { });
                        } else {
                            if (checkoutConfig.phoneLocalizationEnabled) {
                                var $inputPhone = $('.form-row.phone.js-phone-localization input', $element);
                                Validation.isValidPhoneLocalized($scope, 'Control.Form.Phone', $inputPhone, $inputPhone.data('localized-validation'), {

                                }).then(function (response) {
                                }, function (error) {
                                    $scope.Control.IsOpen = true;
                                });
                            } else if ($scope.Control.Form.Country === 'GR' && checkoutConfig.greekPhoneValidation) {
                                $scope.Model.Data.Config.IsGreekPhone = true;
                                Validation.isMatch($scope, 'Control.Form.Phone', /^2[0-9]{9}$/g, {

                                }).then(function (response) {
                                }, function (error) {
                                    $scope.Control.IsOpen = true;
                                });
                            } else {
                                $scope.Model.Data.Config.IsGreekPhone = false;
                                Validation.isMatch($scope, 'Control.Form.Phone', /^[\+]?[\d]+$/g, {

                                }).then(function (response) {
                                }, function (error) { });
                            }
                        }
                    }
                }
            });

            validators.push({
                name: 'Control.Form.Town',
                fn: function () {
                    Validation.reset($scope, 'Control.Form.Town');
                    if ($scope.Model.Data.Config.IsUserCourierCompanyTownVisible && $scope.Model.Data.Config.IsUserCourierCompanyTownRequired) {
                        Validation.require($scope, 'Control.Form.Town').then(function (response) { }, function (error) { });
                    }
                }
            });

            validators.push({
                name: 'Control.Form.Area',
                fn: function () {
                    Validation.reset($scope, 'Control.Form.Area');
                    if ($scope.Model.Data.Config.IsUserCourierCompanyAreaVisible && $scope.Model.Data.Config.IsUserCourierCompanyAreaRequired) {
                        Validation.require($scope, 'Control.Form.Area').then(function (response) { }, function (error) { });
                    }
                }
            });

            validators.push({
                name: 'Control.Form.PostalCode',
                fn: function () {
                    Validation.reset($scope, 'Control.Form.PostalCode');
                    if ($scope.Model.Data.Config.IsUserCourierCompanyPostalCodeVisible && $scope.Model.Data.Config.IsUserCourierCompanyPostalCodeRequired) {
                        Validation.require($scope, 'Control.Form.PostalCode').then(function (response) { }, function (error) { });
                    }
                }
            });

            var validate = function () {
                $scope.Control.IsValid = true;

                if (initiallyValidated) {
                    if ($scope.Order.Current.DeliveryPoint.Code.indexOf("onSite") > -1) 
                        $scope.Control.IsValid = $scope.Control.SelectedMethod != 0 && $scope.Control.SelectedCompany != 0;

                    var ourSelectedMethod = getSelectedMethod();

                    if (ourSelectedMethod && ourSelectedMethod.Code == 'userCourier') {
                        _.first(_.filter(validators, function (x) { return x.name === 'Control.Form.Name' })).fn();
                        _.first(_.filter(validators, function (x) { return x.name === 'Control.Form.Address' })).fn();
                        _.first(_.filter(validators, function (x) { return x.name === 'Control.Form.Phone' })).fn();
                        _.first(_.filter(validators, function (x) { return x.name === 'Control.Form.Town' })).fn();
                        _.first(_.filter(validators, function (x) { return x.name === 'Control.Form.Area' })).fn();
                        _.first(_.filter(validators, function (x) { return x.name === 'Control.Form.PostalCode' })).fn();
                    }
                }
            };

            $element.get(0).validate = function (onComplete) {
                $scope.Control.IsValid = true;

                initiallyValidated = true;
                validate();

                if (typeof (onComplete) === 'function') {
                    setTimeout(function () {
                        onComplete($scope.Control.IsValid);
                    }, 200);
                }
            };

            var savedDataState = {};
            var savedData = new SavedDataState();

            var getSelectedMethod = function () {
                return _.first(_.filter($scope.Model.Data.Methods, function (x) { return x.Id == $scope.Control.SelectedMethod; }));
            };

            var getSelectedCompany = function () {
                var selected = getSelectedMethod();
                if (selected)
                    return _.first(_.filter(selected.Options, function (x) { return x.Id == $scope.Control.SelectedCompany; }));

                return undefined;
            };

            var applyChanges = function () {
                var selectedMethod = getSelectedMethod();
                var selectedCompany = getSelectedCompany();

                $scope.setControlValue(controlName, {
                    Method: selectedMethod,
                    Company: selectedCompany
                });

                if (selectedMethod && selectedCompany) {

                    if (!hasSavedDataStateChanged(selectedMethod, selectedCompany) && !savedData.hasChanged($scope.Control.Form))
                        return;

                    $scope.Control.Loading = false;
                    validate();

                    ControlService.invokeCheckout($scope, $element, 'SetShippingMethod',
                        {
                            MethodId: selectedMethod.Id,
                            MethodName: selectedMethod.Name,
                            CompanyId: selectedCompany.Id,
                            CompanyName: selectedCompany.Name,
                            Description: selectedCompany.Description,
                            Duration: selectedCompany.Duration,
                            AdditionalDuration: selectedCompany.AdditionalDuration,

                            UserCompany: {
                                Name: $scope.Control.Form.Name,
                                Address: $scope.Control.Form.Address,
                                Phone: $scope.Control.Form.Phone,
                                Town: $scope.Control.Form.Town,
                                Area: $scope.Control.Form.Area,
                                PostalCode: $scope.Control.Form.PostalCode,
                            }
                        }).then(function (response) {
                        $scope.Control.Loading = true;
                        setSavedDataState();
                        $scope['ShopAllowancesOrCharges'].Wrapper.reload();

                        $scope.Order.Wrapper.reload().then(function (intResponse) {                           
                            if ($scope.Config.IsExplicitTimeslotEnabled) {
                                $('.x-control.x-angular-control.x-checkoutorderexplicittimeslot').get(0).reload();
                            }
                            $scope.Control.Loading = false;
                        }, function (intError) {
                            $scope.Control.Loading = false;
                            throw intError;
                        });
                      
                    }, function (error) {
                        $scope.Control.Loading = false;
                        throw error;
                    });
                }
            };

            $scope.Control.applyChanges = function () {

                if (!savedData.hasChanged($scope.Control.Form))
                    return;

                $scope.Control.Loading = true;
                applyChanges();
            };

            $scope.Control.AnyAvailableMethods = function () {
                return _.filter($scope.Model.Data.Methods, function (x) { return $scope.Control.IsMethodAvailable(x); }).length > 0;
            };

            $scope.Control.IsOptionAvailable = function(option) {
                if (checkoutOverrides && checkoutOverrides.Shipping && typeof checkoutOverrides.Shipping.IsOptionAvailable === 'function'){
                    return checkoutOverrides.Shipping.IsOptionAvailable(option, $scope.Control, $scope.$parent.Order.Current.Shipping);
                }
                var geoZones = $scope.$parent.Order.Current.Shipping.GeoZones;
                for (var i = 0; i < geoZones.length; i++) {
                    var geoZone = geoZones[i];
                    if (option.AvailableGeoZones.indexOf(geoZone) >= 0) {
                        return true;
                    }
                }
                return false;
            };

            $scope.Control.CalculateVisibility = function (method) {
                if (checkoutOverrides && checkoutOverrides.Shipping && typeof checkoutOverrides.Shipping.CalculateVisibility === 'function') {
                    return checkoutOverrides.Shipping.CalculateVisibility($scope, method);
                }
                return true;
            }

            $scope.Control.IsMethodAvailable = function (method) {
                if (checkoutOverrides && checkoutOverrides.Shipping && typeof checkoutOverrides.Shipping.IsMethodAvailable === 'function') {
                    return checkoutOverrides.Shipping.IsMethodAvailable(method, $scope);
                }				               
                var available = $scope.$parent.DeliveryPoint.Current && method.DeliveryPoints.indexOf($scope.$parent.DeliveryPoint.Current.Id) >= 0;
                if (available && method.Options.length>0) {
                    for (var j = 0; j < method.Options.length; j++) {
                        if ($scope.Control.IsOptionAvailable(method.Options[j]))
                            return true;
                    }
                    return false;
                }
                return available;
            };

            if (checkoutOverrides && checkoutOverrides.Shipping && typeof checkoutOverrides.Shipping.AddWatch === 'function'){
                checkoutOverrides.Shipping.AddWatch($scope);
            }
            
            $scope.Control.setSelectedMethod = function (methodId) {

                var previousMethod = $scope.Control.SelectedMethod;
                $scope.Control.SelectedMethod = methodId;

                if (previousMethod != $scope.Control.SelectedMethod) {
                    resetUserCompanyForm();
                }

                var selectedMethod = getSelectedMethod();
                if (selectedMethod) {
                    var selectedCompany = _.first(_.filter(selectedMethod.Options, function (x) { return x.Id == $scope.Control.SelectedCompany; }));
                    if (selectedCompany == undefined) {
                        $scope.Control.SelectedCompany = 0;
                        $scope.Control.SelectedCompanyCode = '';

                        var firstCompanyOption = _.first(selectedMethod.Options);
                        if (firstCompanyOption) {
                            $scope.Control.SelectedCompany = firstCompanyOption.Id;
                            $scope.Control.SelectedCompanyCode = firstCompanyOption.Code;
                        }
                    }

                    if (selectedMethod.Code.indexOf('fromStore') > -1) {
                        var stScope = angular.element('.x-control.x-angular-control.x-checkoutstore').scope();
                        stScope.Control.setStoreShippingCost();
                    }
                }

                var pmScope = angular.element('.x-control.x-angular-control.x-checkoutpaymentmethod').scope();
                $scope.Model.Data.Methods.forEach(function (th) {
                    if (th.Id == methodId) {
                        if (!$scope.$parent.PaymentMethod.Current || th.PaymentMethods.indexOf($scope.$parent.PaymentMethod.Current.Id) < 0) {
                            pmScope.Control.setSelected(th.PaymentMethods[0], 0, th.PaymentMethods);
                            pmScope.Control.applyChanges(false);
                        }
                    }
                });

                applyChanges();
            };

            $scope.Control.setSelectedCompany = function (companyId) {

                var previousComp = $scope.Control.SelectedCompany;
                $scope.Control.SelectedCompany = companyId;

                if (previousComp != $scope.Control.SelectedCompany) {
                    resetUserCompanyForm();
                }

                var selectedCompany = getSelectedCompany();
                $scope.Control.SelectedCompanyCode = selectedCompany ? selectedCompany.Code : '';

                applyChanges();

                if ($scope['PaymentMethod'] && $scope['PaymentMethod'].Wrapper && typeof ($scope['PaymentMethod'].Wrapper.reload) == 'function') {
                    $scope['PaymentMethod'].Wrapper.reload();
                }
            };

            var resetUserCompanyForm = function () {
                $scope.Control.Form.Name = "";
                $scope.Control.Form.Address = "";
                $scope.Control.Form.Phone = "";
                $scope.Control.Form.Town = "";
                $scope.Control.Form.Area = "";
                $scope.Control.Form.PostalCode = "";
            };

            var applyModel = function () {
                var shouldSetDefault = false;
                if ($scope['Order'] &&
                    $scope['Order'].Current &&
                    $scope['Order'].Current.ShippingMethod) {

                    var matchedOption = _.first(_.filter($scope.Model.Data.Methods, function (x) { return x.Id == $scope['Order'].Current.ShippingMethod.MethodId; }));

                    if (matchedOption) {
                        $scope.Control.SelectedMethod = matchedOption.Id;
                    } else {
                        matchedOption = _.first(_.filter($scope.Model.Data.Methods, function (x) { return $scope.Control.IsMethodAvailable(x); }));
                        if (matchedOption) {
                            shouldSetDefault = true;
                            $scope.Control.SelectedMethod = matchedOption.Id;
                        }
                    }
                }

                var selectedMethod = getSelectedMethod();
                if (selectedMethod) {
                    if ($scope['Order'] && $scope['Order'].Current && $scope['Order'].Current.ShippingMethod) {
                        var matchedOption = _.first(_.filter(selectedMethod.Options, function (x) { return x.Id == $scope['Order'].Current.ShippingMethod.CompanyId; }));

                        if (matchedOption) {
                            $scope.Control.SelectedCompany = matchedOption.Id;
                            $scope.Control.SelectedCompanyCode = matchedOption.Code;
                            $scope.Control.Form = $scope['Order'].Current.ShippingMethod.UserCompany;
                        } else {
                            matchedOption = _.first(_.filter(selectedMethod.Options, function (x) { return $scope.Control.IsOptionAvailable(x); }));
                            if (matchedOption) {
                                shouldSetDefault = true;
                                $scope.Control.SelectedCompany = matchedOption.Id;
                                $scope.Control.SelectedCompanyCode = matchedOption.Code;
                            }
                        }
                    }

                    if (selectedMethod.Code.indexOf('fromStore') > -1) {
                        var stScope = angular.element('.x-control.x-angular-control.x-checkoutstore').scope();
                        stScope.Control.setStoreShippingCost();
                    }
                }

                var selectedCompany = getSelectedCompany();
                $scope.setControlValue(controlName, {
                    Method: selectedMethod,
                    Company: selectedCompany
                });

                validate();

                if (shouldSetDefault) applyChanges();
            };
            
            $element.get(0).set = function () {
                var deferred = $q.defer();

                var selectedMethod = getSelectedMethod();
                var selectedCompany = getSelectedCompany();

                $scope.setControlValue(controlName, {
                    Method: selectedMethod,
                    Company: selectedCompany
                });

                if (selectedMethod && selectedCompany) {

                    if (!hasSavedDataStateChanged(selectedMethod, selectedCompany))
                        return;

                    ControlService.invokeCheckout($scope, $element, 'SetShippingMethod',
                        {
                            MethodId: selectedMethod.Id,
                            MethodName: selectedMethod.Name,
                            CompanyId: selectedCompany.Id,
                            CompanyName: selectedCompany.Name,
                            Description: selectedCompany.Description,
                            Duration: selectedCompany.Duration,
                            AdditionalDuration: selectedCompany.AdditionalDuration,

                            UserCompany: {
                                Name: $scope.Control.Form.Name,
                                Address: $scope.Control.Form.Address,
                                Phone: $scope.Control.Form.Phone,
                                Town: $scope.Control.Form.Town,
                                Area: $scope.Control.Form.Area,
                                PostalCode: $scope.Control.Form.PostalCode,
                            }
                        }).then(function (response) {
                        deferred.resolve(response);
                        $scope.Control.Loading = false;
                    }, function (error) {
                        deferred.reject(error);
                        $scope.Control.Loading = false;
                    });
                }

                return deferred.promise;
            };

            $element.get(0).reload = function () {
                var deferred = $q.defer();

                $scope.Control.CustomShippingCalculationApplied = false;

                ControlService.getCheckoutData("GetShippingMethodData", $scope, $element).then(function (response) {
                    $scope.Model = {};
                    if (checkoutOverrides && checkoutOverrides.Shipping && typeof checkoutOverrides.Shipping.TransformData === 'function') {
                        checkoutOverrides.Shipping.TransformData(response, $scope);
                    }
                    angular.extend($scope.Model, response);
                    applyModel();
                    deferred.resolve(response);
                    $scope.Control.Loading = false;
                }, function (error) {
                    deferred.reject(error);
                    $scope.Control.Loading = false;
                });
                return deferred.promise;
            };

            $scope.$parent.$watch('Order.Current.ProductsQuantity', function (newValue, prevValue) {

                if (!prevValue || !newValue)
                    return;

                if (prevValue !== newValue) {
                    $element.get(0).reload();
                }
            });

            var setSavedDataState = function () {

                var selectedMethod = getSelectedMethod();
                var selectedCompany = getSelectedCompany();

                savedDataState = {
                    "selectedMethodId": selectedMethod ? selectedMethod.Id : 0,
                    "selectedCompanyId": selectedCompany ? selectedCompany.Id : 0,
                    "savedForm": $scope.Control.Form
                };
            };

            var hasSavedDataStateChanged = function (selectedMethod, selectedCompany) {
                var hasChanges = false;

                if (!selectedMethod)
                    selectedMethod = { "Id": 0 };

                if (!selectedCompany)
                    selectedCompany = { "Id": 0 };

                if (savedDataState.selectedMethodId != selectedMethod.Id || savedDataState.selectedCompanyId != selectedCompany.Id)
                    hasChanges = true;

                return hasChanges;
            };

            ControlService.getCheckoutData("GetShippingMethodData", $scope, $element).then(function (response) {
                $scope.Model = {};
                if (checkoutOverrides && checkoutOverrides.Shipping && typeof checkoutOverrides.Shipping.TransformData === 'function') {
                    checkoutOverrides.Shipping.TransformData(response, $scope);
                }
                angular.extend($scope.Model, response);
                if (checkoutOverrides && checkoutOverrides.Shipping && typeof checkoutOverrides.Shipping.ExtendModel === 'function'){
                    $.extend($scope.Control,checkoutOverrides.Shipping.ExtendModel($scope.Control, $scope.$parent.Order.Current));
                }

                applyModel();

                setSavedDataState();

                $scope.Control.Loading = false;
            }, function (error) {
                $scope.Control.Loading = false;
                throw error;
            });

            angular.element($element.get(0)).ready(function () {
                if (checkoutOverrides && checkoutOverrides.Generic && typeof checkoutOverrides.Generic.initPhoneLocalization === 'function') {
                    if (checkoutConfig.phoneLocalizationEnabled) checkoutOverrides.Generic.initPhoneLocalization($element.get(0), $scope);
                }
            });

        });
})();